<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('diarios')">Comercial:</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.contact}}
    </h1>
    <trashed-message v-if="diariosdetalles.deleted_at" class="mb-6" @restore="restore">
     El Comercial fue Eliminado!
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model.number="form.id_reporte" :error="form.errors.last_name" class="pr-6 pb-8 w-24" label="Número Reporte" />

          <text-input v-model="form.proyecto" :error="form.errors.first_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Proyecto" />
          <text-input v-model.number="form.valor_total" :error="form.errors.last_name" class="pr-6 pb-8 w-48" label="Valor Total" />
          <text-input v-model.number="form.entrada" :error="form.errors.last_name" class="pr-6 pb-8 w-32" label="Entrada" />
          <text-input v-model.number="form.plazo" :error="form.errors.last_name" class="pr-6 pb-8 w-32" label="Plazo" />
          <text-input v-model.number="form.cuota" :error="form.errors.last_name" class="pr-6 pb-8 w-32" label="Cuota M." />
          
          <text-input v-model.number="form.deuda" :error="form.errors.last_name" class="pr-6 pb-8 w-32" label="Deuda"/>
        
          <text-input v-model.number="form.total" :error="form.errors.last_name" class="pr-6 pb-8 w-32" label="Comisión" />
        




         
                   </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
     <button v-if="!diariosdetalles.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Venta</button>
       <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Actualizar Venta</loading-button>
        </div>
      </form><!--
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Nombres</th>
          <th class="px-6 pt-6 pb-4">Meta</th>
          <th class="px-6 pt-6 pb-4">Empresa</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Cumplimiento</th>
        </tr>
        <tr v-for="diariodetalle in diariosdetalles.data" :key="diariodetalle.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('contacts.edit', diariodetalle.id)" tabindex="-1">
              {{ diariodetalle.proyecto }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('contacts.edit', diariodetalle.id)">
              {{ diariodetalle.valor_total }}
              <icon v-if="diariodetalle.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('contacts.edit',diariodetalle.id)" tabindex="-1">
              <div v-if="diariodetalle.contact">
                {{ diariodetalle.contact.nombres }}
              </div>
            </inertia-link>
          </td>
         
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('contacts.edit', diariodetalle.id)" tabindex="-1">
              {{ diariodetalle.deuda }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('contacts.edit', diariodetalle.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
       
      </table>-->
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: `${this.form.contact}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
   diariosdetalles: Object,
   contacts: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
          id_reporte: this.diariosdetalles.reporte_diario_id,
       proyecto: this.diariosdetalles.proyecto,
        valor_total: this.diariosdetalles.valor_total,
        contact: this.contacts.nombres,
        entrada: this.diariosdetalles.entrada,
        plazo: this.diariosdetalles.plazo,
        cuota: this.diariosdetalles.cuota,
        deuda: this.diariosdetalles.deuda,
        total: this.diariosdetalles.total,


      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('diariosdetalles.update', this.diariosdetalles.id))
    },
    destroy() {
      if (confirm('Estas Seguro de Eliminar?')) {
        this.$inertia.delete(this.route('diariosdetalles.destroy', this.diariosdetalles.id))
      }
    },
    restore() {
      if (confirm('Piensalo Bien!?')) {
        this.$inertia.put(this.route('contacts.restore', this.diariosdetalles.id))
      }
    },
  },
}
</script>
